import axios from "axios";

class ApiProvider {

  constructor(baseURL = "") {
    this.baseURL = baseURL;
    this.instance = axios.create({ baseURL });
  }

  get   = (url = "", config = {}) => this.instance.get(url, config);

  post  = (url = "", data = {}, config = {}) => this.instance.post(url, data, config);

  put   = (url = "", data = {}, config = {}) => this.instance.put(url, data, config);

  patch = (url = "", data = {}, config = {}) => this.instance.patch(url, data, config);

  delete = (url = "", config = {}) => this.instance.delete(url, config);
}
export default ApiProvider;
